
import React, { Component}  from 'react';

import { FormContext } from 'core/FormProvider';
import {ContextFormControlWidget, ContextWidget} from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import FormGroup from 'form/FormGroup';
import {AsyncAutocompleteWidget} from "form/AutocompleteWidget";
import DateMaskedWidget from "form/DateMaskedWidget";
import AddShipperDialog from "./AddShipperDialog";
import AddConsigneeDialog from "./AddConsigneeDialog";


export default class ExtraOrderFieldForm extends Component {

  render() {
    return (
      <FormContext.Consumer>
        {context => {
          return (
            <React.Fragment>

              <h3>Дополнительные поля</h3>

              <FormGroup>

                <ContextWidget
                  name={`description`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Примечание к перевозке',
                    multiline: true
                  }}
                />

                <ContextWidget
                  name={`station_arrival_comment`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Комментарий о приходе на станцию',
                    multiline: true
                  }}
                />

                <ContextWidget
                  name={`cargo`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Груз',
                    multiline: true
                  }}
                />

                <ContextWidget
                  name={`hbl_date`}
                  WidgetComponent={DateMaskedWidget}
                  widgetProps={{
                    label: 'Дата HBL'
                  }}
                />

                <ContextWidget
                  name={`empty_arrival_info`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Инструкции по сдаче порожнего',
                    multiline: true
                  }}
                />

                <ContextWidget
                  name={`empty_arrival_date`}
                  WidgetComponent={DateMaskedWidget}
                  widgetProps={{
                    label: 'Дата сдачи порожнего'
                  }}
                />

                <ContextFormControlWidget
                  name={'shipper'}
                  WidgetComponent={AsyncAutocompleteWidget}
                  widgetProps={{
                    label: 'Грузоотправитель',
                    url: 'catalog/choice',
                    filter: {
                      type: 'SHIPPER'
                    },
                    dialogTitle: 'Новый грузоотправитель',
                    DialogComponent: AddShipperDialog
                  }}
                />

                <ContextFormControlWidget
                  name={'consignee'}
                  WidgetComponent={AsyncAutocompleteWidget}
                  widgetProps={{
                    label: 'Грузополучатель',
                    url: 'catalog/choice',
                    filter: {
                      type: 'CONSIGNEE'
                    },
                    dialogTitle: 'Новый грузополучатель',
                    DialogComponent: AddConsigneeDialog
                  }}
                />
              </FormGroup>

            </React.Fragment>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
